import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import { set_interval } from '@/utils/utils_client';
import { DTO__ml_asset_reservation } from '@shared/dto/+model/reservation/DTO__ml_asset_reservation';
import { format_time_with_unit, timestamp_ms } from '@shared/utils/utils_time';
import { useRef } from 'react';

export function WatcherDiffusionModelsTitle() {
  const { reservations_current_workspace_active_map } = use_slice_ml_asset(['reservations_current_workspace_active_map']);

  const ref_interval = useRef<number>(NaN);

  /*
   * EFFECTS
   */

  use_effect(() => {
    clearInterval(ref_interval.current);

    let reservations_list = get_top_active_reservations();

    if (reservations_list.length == 0) return set_title('ULTIMATE DIFFUSION');

    update_title(reservations_list);

    ref_interval.current = set_interval(() => update_title(reservations_list), 1000);

    return () => clearInterval(ref_interval.current);
  }, [reservations_current_workspace_active_map]);

  /*
   * METHODS
   */

  function update_title(reservations_list: DTO__ml_asset_reservation[] = []) {
    let timers_strings: string[] = [];

    for (let reservation of reservations_list) {
      let time_left_number = reservation.expired_at - timestamp_ms();

      if (time_left_number > CONSTANTS__client.DIFFUSION_MODELS_TIME_LEFT_TITLE_CRITERIA) continue;

      let time_left_string = format_time_with_unit(time_left_number);

      timers_strings.push(time_left_string);
    }

    let title = timers_strings.join(' | ');

    set_title(title);
  }

  function get_top_active_reservations() {
    let reservations_current_workspace_active = Array.from(reservations_current_workspace_active_map.values());

    let resetvations_list_all = reservations_current_workspace_active.flatMap(item => Array.from(item.values()));
    resetvations_list_all = resetvations_list_all.sort(DTO__ml_asset_reservation.sort_by_expired_at_z_to_a);
    //key - diffusion model id
    let out_map = new Map<string, DTO__ml_asset_reservation>();

    for (let reservation of resetvations_list_all) {
      let reservation_from_map = out_map.get(reservation.diffusion_model_id) || reservation;

      let reservation_to_add = reservation.expired_at > reservation_from_map.expired_at ? reservation : reservation_from_map;

      out_map.set(reservation_to_add.diffusion_model_id, reservation_to_add);
    }

    let out = Array.from(out_map.values());
    out = out.sort(DTO__ml_asset_reservation.sort_by_expired_at_a_to_z);
    out = out.slice(0, CONSTANTS__client.DIFFUSION_MODELS_TIMERS_AMOUNT_IN_TITLE);

    return out;
  }

  function set_title(title: string) {
    document.title = title;
  }

  return null;
}
